export default __webpack_public_path__ + "images/P9.f988ee1.png";